import { createRouter } from '@tanstack/react-router';

import { routeTree } from '../routeTree.gen';

/**
 * الموجّه الوحيد للتطبيق (§1.2): file-based routing، وكل مسار chunk مستقل عبر
 * `autoCodeSplitting` في vite.config.ts — ميزانية §7 تفرض ≤ 60KB gz للمسار.
 *
 * لا loaders تجلب بيانات: TanStack Query هو مخزن حالة الخادم الوحيد (§1.1)،
 * فـ `defaultPreloadStaleTime: 0` يعني «لا تكذب من كاش الموجّه» — الكاش كاش Query.
 */
export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  defaultPreloadStaleTime: 0,
  scrollRestoration: true,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
